import React, { useState, useEffect } from 'react';
import { Typography } from '@material-ui/core';
import { getOrderDetailsById } from '../../actions/orders';
import { useParams } from "react-router-dom";
import Loader from '../common/Loader';

const Itempayments = (props) => {
  const classes = props.classes;
  //console.log("props",props)
  // console.log("props login",props.login)
  let session = sessionStorage.getItem('user');
  // const [countryid, setCountryid] = useState(session ? `${JSON.parse(session).countryId}` : "");
  let orderId = props.orderId;
  const [itemdet, setItemDet] = useState([]);
  const [msg, setMsg] = useState("");
  const [msgstatus, setMsgStatus] = useState();
  const [currency, setcurrency] = useState("");
  const [orderdet, setOrderDet] = useState([]);

  useEffect(() => {
    getOrderDetailsById(orderId).then((response) => {
      const resData = (response && response.data) || {}
      setMsgStatus(resData.status);
      setMsg(resData.ResponseText);

      const orderData = resData.ResponseData || {}
      let orderDetails = {}
      if (orderData.data && orderData.data && orderData.data.length > 0) {
        orderDetails = orderData.data[0].order
      }
      setItemDet(orderData.data || "");
      setOrderDet(orderDetails || "");
      setcurrency(orderData.data && orderData.data.length > 0 ? orderData.data[0].currency : "");
    })
  }, []);

  const setFullfillmentStatus = (statusText) => {
    if (!statusText) {
      return statusText
    }

    statusText = statusText.toString().toLowerCase().replace('_', " ")
    return statusText[0].toUpperCase() + statusText.slice(1, statusText.length)
  }

  return (
    <div>
      {msgstatus !== 200 && <div className={classes && classes.errorwrap}><h1>{msg}</h1></div>}
      {(msgstatus === 200 && itemdet && itemdet.length === 0) && <Loader />}
      <div style={{ padding: "20px" }}>
        <table border="1" cellPadding="1" cellSpacing="1" style={{ width: "100%", borderCollapse: "separate" }}>
          <thead>
            <tr>
              <th style={{ padding: "5px" }}>Dish</th>
              <th style={{ padding: "5px" }}>Dish Name</th>
              <th style={{ padding: "5px" }}>Dish Category</th>
              <th style={{ padding: "5px" }}>Weight</th>
              <th style={{ padding: "5px" }}>Quantity</th>
              <th style={{ padding: "5px" }}>Amount</th>
              {/* <th style={{ padding: "5px" }}>CashBack</th> */}
              {/* <th style={{ padding: "5px" }}>Coupon Code</th> */}
              {/* <th style={{ padding: "5px" }}>Discount</th> */}
              {/* <th style={{ padding: "5px" }}>Refund Amount</th> */}
              <th style={{ padding: "5px" }}>Total Amount</th>
              <th style={{ padding: "5px" }}>Fulfillment Status</th>
            </tr>
          </thead>
          <tbody>
            {itemdet && itemdet.map((s, sIndex) => {
              const image_url = s.food_items && s.food_items.length > 0 && s.food_items[0].food_item_images && s.food_items[0].food_item_images.length > 0 && s.food_items[0].food_item_images[0].image_url

              return (
                <tr key={sIndex}>
                  <td style={{ width: '70px', padding: "5px" }}><img src={image_url} /></td>
                  <td style={{ padding: "5px" }}>{s.item_name}</td>
                  <td style={{ padding: "5px" }}>{s.food_item && s.food_item.category && s.food_item.category.category_name || "-"}</td>
                  <td style={{ padding: "5px" }}>{s.weight}</td>
                  <td style={{ padding: "5px" }}>{s.quantity}</td>
                  <td style={{ padding: "5px" }}>{<span>&#8377;</span>}{s.amount || 0}</td>
                  {/* <td style={{ padding: "5px" }}>{(s.currency === "&#8377;") ? <span>&#8377;</span> : <span>&#36;</span>}{s.cashBack}</td> */}
                  {/* <td style={{ padding: "5px" }}>{s.couponCode}</td> */}
                  {/* <td style={{ padding: "5px" }}>{(s.currency === "&#8377;") ? <span>&#8377;</span> : <span>&#36;</span>}{s.discount}</td> */}
                  {/* <td style={{ padding: "5px" }}>{(s.currency === "&#8377;") ? <span>&#8377;</span> : <span>&#36;</span>}{s.refundAmount}</td> */}
                  <td style={{ padding: "5px" }}>{<span>&#8377;</span>}{s.net_amount || 0}</td>
                  <td style={{ padding: "5px" }}>{(setFullfillmentStatus(orderdet && orderdet.fulfillment_status)) || "-"}</td>
                </tr>
              );
            })}
            {/* <tr>
              <td colSpan="5" style={{ padding: "5px" }}>Delivery Charges : <strong>{(currency === "&#8377;") ? <span>&#8377;</span> : <span>&#36;</span>}{orderdet.deliveryCharges ? orderdet.deliveryCharges : "0.0"}</strong></td>
              <td colSpan="6" style={{ padding: "5px" }}>Shipping Charges : <strong>{(currency === "&#8377;") ? <span>&#8377;</span> : <span>&#36;</span>}{orderdet.shippingCharges ? orderdet.shippingCharges : "0.0"}</strong></td>
            </tr> */}
            {/* <tr>
              <td colSpan="3" style={{ padding: "5px" }}>CashBack : <strong>{(currency === "&#8377;") ? <span>&#8377;</span> : <span>&#36;</span>}{orderdet.cashBack ? orderdet.cashBack : "0"}</strong></td>
              <td colSpan="4" style={{ padding: "5px" }}>Discount : <strong>{(currency === "&#8377;") ? <span>&#8377;</span> : <span>&#36;</span>}{orderdet.discount ? orderdet.discount : "0.0"}</strong></td>
              <td colSpan="4" style={{ padding: "5px" }}>Coupon Discount : <strong>{(currency === "&#8377;") ? <span>&#8377;</span> : <span>&#36;</span>}{orderdet.couponDiscount ? orderdet.couponDiscount : "0.0"}</strong></td>
            </tr> */}
            <tr>
              {/* <td colSpan="3" style={{ padding: "5px" }}>Convenience Fees : <strong>{(currency === "&#8377;") ? <span>&#8377;</span> : <span>&#36;</span>}{orderdet.convenienceFees ? orderdet.convenienceFees : "0.0"}</strong></td> */}
              <td colSpan="2" style={{ padding: "5px" }}>Amount : <strong>{<span>&#8377;</span>}{props.orderData.order && props.orderData.order.amount ? props.orderData.order.amount : "0.0"}</strong></td>
              <td colSpan="2" style={{ padding: "5px" }}>Delivery Charges : <strong>{<span>&#8377;</span>}{props.orderData.order && props.orderData.order.delivery_charges ? props.orderData.order.delivery_charges : "0.0"}</strong></td>
              <td colSpan="4" style={{ padding: "5px" }}>{props.orderData.order && props.orderData.order.tax_name ? props.orderData.order.tax_name : "Tax"} : <strong>{<span>&#8377;</span>}{props.orderData.order.tax ? props.orderData.order.tax : "0.0"}</strong></td>
            </tr>
            <tr>
              <td colSpan="11" style={{ padding: "5px" }}>Total Amount : <strong>{<span>&#8377;</span>}{props.orderData.order && props.orderData.order.net_amount ? props.orderData.order.net_amount : "0.0"}</strong></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  )
};

export default Itempayments;
